import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draft from "../email/components/draft.vue";
import addEmperor from "../banUser/components/add.vue";
import unseal from "../banUser/components/unseal.vue";
import { userDetail, userEmail, banedUserList, banUser, userInfoOperationProp, paySupplementList, userBanLog, gmDagDesc, gmRechargeGame, gmResourceDescList } from "@/api/gmtool/packageCode";
import { szUserInfoNew, SzBagDesc, SzesourceDescList, SzRechargeGame, repairOrderData, SzEmailList, SzBanedUserList, SzRechargeGameCurrency, SzRechargeGameAllCurrency, SzRechargeGameAll, getSzLoginList, bagRetainDesc, equipResource } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, tabulation, gmToolNewPage } from "@/mixins/index";
import pickerOption from "@/mixins/module/pickerOption";
import { serchSelect } from "@/mixins/index";
import emailDetils from "../email/components/emailDetils.vue";
import viewArticles from "../email/components/viewArticles.vue";
import bindPhone from "./components/bindPhone.vue";
import addExport from "./components/addExport.vue";
import { size } from "lodash";
export default {
  name: "playerDetails_yujian",
  mixins: [gmToolNew, pickerOption, serchSelect, tabulation, gmToolNewPage],
  components: {
    draft: draft,
    addEmperor: addEmperor,
    unseal: unseal,
    emailDetils: emailDetils,
    viewArticles: viewArticles,
    bindPhone: bindPhone,
    addExport: addExport
  },
  data: function data() {
    return {
      reqLoadingOne: false,
      reqLoadingTow: false,
      popData: {
        server_id: ''
      },
      exportLoading: false,
      exportLoadingt: false,
      date: [],
      radio: 2,
      dialog: false,
      total: 0,
      paramsData: {
        user_id: "",
        server_id: "",
        role_id: "",
        role_name: "",
        env_id: "",
        account: ""
      },
      kindList: [{
        label: this.$t('output'),
        value: "output"
      }, {
        label: this.$t('consumption'),
        value: "cost"
      }, {
        label: this.$t('retention'),
        value: "retain"
      }],
      tabbleData: [{}],
      currentPage: 1,
      bgCurrentPage: 1,
      bgPageSize: 10,
      propertyCurrentPage1: 1,
      propertyPageSize1: 10,
      tablePropertyTableList: [],
      searchList: [],
      featureList: [{
        title: this.$t('items'),
        id: "2"
      }, {
        title: this.$t('equipmentResources'),
        id: "8"
      }, {
        title: this.$t('orders'),
        id: "3"
      }, {
        title: this.$t('mailbox'),
        id: "4"
      }, {
        title: this.$t('operations'),
        id: "5"
      }, {
        title: this.$t('loginData'),
        id: "6"
      }, {
        title: this.$t('playerBackpackDetails'),
        id: "7"
      }],
      controlsSort: [{
        title: this.$t('replenishmentLog'),
        index: 0,
        reqFn: repairOrderData,
        paramsData: {
          page_size: 10
        },
        list: [],
        page: 1,
        total: 0
      }, {
        title: this.$t('banLog'),
        index: 1,
        reqFn: SzBanedUserList,
        paramsData: {
          page_size: 10
        },
        list: [],
        total: 0
      }],
      controlsSortIndex: 0,
      checkedCities: "2",
      supplement: [{
        label: this.$t('reissueReward'),
        value: "supplement_reward"
      }, {
        label: this.$t('reissueOrder'),
        value: "supplement_product"
      }],
      codeLists: [],
      isCode: false,
      detailsData: [],
      userData: {
        starttime: "",
        endtime: "",
        user_id: "",
        server_id: "",
        role_id: ""
      },
      propertyparamsData: {
        output: '',
        cost: '',
        resource_id: "",
        kind: "",
        page_size: 10,
        page: 1
      },
      property: [],
      propertyTotal: 0,
      orderData: [],
      orderparamsData: {
        page: 1,
        page_size: 10,
        kind: 1,
        currency_info: ""
      },
      equipmentData: [],
      equipmentparamsData: {
        page: 1,
        page_size: 10,
        equip: '',
        cost: '',
        output: ''
      },
      equipmentTotal: 0,
      orderTotal: 0,
      emailList: [],
      emperorType: 1,
      emperorData: {},
      queryData: {},
      singledate: [],
      loginList: [],
      bagRetainList: [],
      bagRetainparamsData: {
        desc_name: ''
      },
      bgTableCopyTableList: [],
      exportdataDealoading: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.szgmEnv[0].id;

            case 2:
              _this.paramsData.env_id = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  activated: function activated() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.queryData = _this2.$route.params;

              if (_this2.queryData.user_id) {
                _this2.paramsData.role_id = _this2.queryData.user_id;
              }

              if (!_this2.queryData.id) {
                _context2.next = 11;
                break;
              }

              _this2.paramsData.role_id = _this2.queryData.id;
              _this2.paramsData.env_id = _this2.queryData.env_id;
              _this2.server_channel = _this2.queryData.server_channel;
              _this2.show_test = _this2.queryData.show_test;
              _context2.next = 9;
              return _this2.getServerList();

            case 9:
              _this2.paramsData.server_id = _this2.queryData.server_id;

              _this2.searchClick();

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.date[0] = date;
      this.date[1] = date;
      this.userData.endtime = date;
      this.singledate[0] = date;
      this.singledate[1] = date;
    },
    typeChange: function typeChange(e) {
      this.paramsData.role_name = "";
      this.paramsData.role_id = "";
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getsearchDate();

                _this3.searchList = [];
                _this3.detailsData = [];
                _this3.total = 0;
                _this3.paramsData = {
                  user_id: "",
                  server_id: _this3.paramsData.server_id,
                  role_id: "",
                  role_name: "",
                  page: 1
                };

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    propertyhandleCurrentChange: function propertyhandleCurrentChange(val) {
      this.propertyparamsData.page = val;
      this.getpropertyList();
    },
    propertyhandleCurrentChangeSizeChange: function propertyhandleCurrentChangeSizeChange(e) {
      this.propertyparamsData.page_size = e;
      this.propertyparamsData.page = 1;
      this.getpropertyList();
    },
    orderhandleCurrentChange: function orderhandleCurrentChange(val) {
      this.orderparamsData.page = val;
      this.getOrderList();
    },
    orderhandleCurrentChangeSizeChange: function orderhandleCurrentChangeSizeChange(e) {
      this.orderparamsData.page_size = e;
      this.orderparamsData.page = 1;
      this.getOrderList();
    },
    equipmenthandleCurrentChange: function equipmenthandleCurrentChange(val) {
      this.equipmentparamsData.page = val;
      this.getequipmentFn();
    },
    equipmenthandleCurrentChangeSizeChange: function equipmenthandleCurrentChangeSizeChange(e) {
      this.equipmentparamsData.page_size = e;
      this.equipmentparamsData.page = 1;
      this.getequipmentFn();
    },
    dataChange: function dataChange() {
      this.userData.starttime = this.date[0];
      this.userData.endtime = this.date[1];
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(e) {
      this.paramsData.pkg = "";
      this.paramsData.ad_channel = "";
      this.paramsData.ad_placement = "";
      this.userData.starttime = this.date[0];
      this.userData.endtime = this.date[1];
      this.propertyparamsData.page = 1;
      this.orderparamsData.page = 1;
      this.equipmentparamsData.page = 1;
      this.userData.user_id = this.detailsData[0].user_id;
      this.userData.role_id = this.detailsData[0].role_id;
      this.userData.server_id = this.detailsData[0].server_id;

      if (e == 1) {
        this.getBackpackDetails();
      } else if (e == 2) {
        this.getpropertyList();
      } else if (e == 3) {
        this.getOrderList();
      } else if (e == 4) {
        this.getuserEmail();
      } else if (e == 6) {
        this.getSzLoginListFn();
      } else if (e == 7) {
        this.getbagRetainDescFn();
      } else if (e == 8) {
        this.getequipmentFn();
      }
    },
    handleCurrentChange: function handleCurrentChange(val, index) {
      this.controlsSort[index].page = val;
      this.operationLogChange(index);
    },
    handleCurrentChangeSizeChange: function handleCurrentChangeSizeChange(e, index) {
      this.controlsSort[index].paramsData.page_size = e;
      this.controlsSort[index].page = 1;
      this.operationLogChange(index);
    },
    operationLogChange: function operationLogChange(e) {
      var _this4 = this;

      this.controlsSort[e].list = [];
      this.$nextTick(function () {
        _this4.reqLoadingTow = true;

        _this4.controlsSort[e].reqFn(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this4.paramsData), _this4.controlsSort[e].paramsData), {}, {
          page: _this4.controlsSort[e].page
        }, _this4.userData), {}, {
          uids: _this4.userData.role_id,
          uid: _this4.userData.role_id
        })).then(function (res) {
          if (res.status == 200) {
            _this4.controlsSort[e].list = res.data.data;
            _this4.controlsSort[e].total = res.data.total;

            _this4.$nextTick(function () {
              _this4.$refs.container.scrollBy(0, 1000000);
            });
          }
        }).finally(function () {
          _this4.reqLoadingTow = false;
        });
      });
    },
    viewCode: function viewCode(data) {
      this.codeLists = JSON.parse(data);
      this.isCode = true;
    },
    viewDetail: function viewDetail(row) {
      var _this5 = this;

      this.detailsData = [row];
      this.handleCheckedCitiesChange(this.checkedCities);
      this.$nextTick(function () {
        _this5.$refs.container.scrollBy(0, 1000000);
      });
    },
    mereList: function mereList() {
      var _this6 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
          var that, list, page, total, getList, _getList;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _getList = function _getList3() {
                    _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pages) {
                      return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              page = pages;
                              _context4.next = 3;
                              return szUserInfoNew(_objectSpread(_objectSpread(_objectSpread({}, that.paramsData), that.defaultData()), {}, {
                                page: pages,
                                page_size: 10
                              })).then(function (res) {
                                if (res.status == 200) {
                                  res.data.data.forEach(function (i) {
                                    i.recharge_amount = that.$utils.conversion(i.recharge_amount).toFixed(2);
                                    i.real_time_amount = that.$utils.conversion(i.real_time_amount).toFixed(2);
                                    i.device_id = i.last_logins ? i.last_logins.device_id : "/";
                                    i.last_login_time = i.last_login_time ? i.last_login_time : "/";
                                    i.register_time = i.register_time ? i.register_time : "/";
                                  });
                                  list = [].concat(_toConsumableArray(list), _toConsumableArray(res.data.data));
                                  total = res.data.total;

                                  if (list.length < total) {
                                    getList(page += 1);
                                  } else {
                                    resolve(list);
                                  }
                                }
                              }).finally(function () {});

                            case 3:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));
                    return _getList.apply(this, arguments);
                  };

                  getList = function _getList2(_x3) {
                    return _getList.apply(this, arguments);
                  };

                  _this6.exportLoadingt = true;
                  that = _this6;
                  list = [];
                  page = 1;
                  total = 0;
                  getList(page);

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    exportDtl: function exportDtl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                szUserInfoNew(_objectSpread(_objectSpread(_objectSpread({}, _this7.paramsData), _this7.defaultData()), {}, {
                  page_size: -1
                })).then(function (res) {
                  if (res.status == 200) {
                    var _list = [];
                    res.data.data.forEach(function (i) {
                      i.recharge_amount = _this7.$utils.conversion(i.recharge_amount).toFixed(2);
                      i.real_time_amount = _this7.$utils.conversion(i.real_time_amount).toFixed(2);
                      i.device_id = i.last_logins ? i.last_logins.device_id : "/";
                      i.last_login_time = i.last_login_time ? i.last_login_time : "/";
                      i.register_time = i.register_time ? i.register_time : "/";
                    });
                    _list = res.data.data;
                    var columns = [{
                      label: _this7.$t('serverId'),
                      prop: "server_id"
                    }, {
                      label: _this7.$t('roleName'),
                      prop: "role_name"
                    }, {
                      label: _this7.$t('roleId'),
                      prop: "role_id"
                    }, {
                      label: _this7.$t('account'),
                      prop: "account"
                    }, {
                      label: _this7.$t('gatewayUserId'),
                      prop: "gate_user_id"
                    }, {
                      label: _this7.$t('prestigeLevel'),
                      prop: "level"
                    }, {
                      label: _this7.$t('totalPower'),
                      prop: "fighting"
                    }, {
                      label: _this7.$t('totalRechargeAmount'),
                      prop: "recharge_amount"
                    }, {
                      label: _this7.$t('realTimeRechargeAmount'),
                      prop: "real_time_amount"
                    }, {
                      label: _this7.$t('thirdPartyLoginType'),
                      prop: "third_login_type"
                    }, {
                      label: _this7.$t('recentLoginDeviceId'),
                      prop: "device_id"
                    }, {
                      label: _this7.$t('extendedParams'),
                      prop: "ext"
                    }, {
                      label: _this7.$t('registerTime'),
                      prop: "register_time"
                    }, {
                      label: _this7.$t('recentLoginTime'),
                      prop: "last_login_time"
                    }];
                    var data = _list;

                    _this7.$export.excel({
                      columns: columns,
                      data: data,
                      title: _this7.$route.meta.title
                    });
                  }
                });

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    searchClick: function searchClick(e, type) {
      var _this8 = this;

      if (!this.paramsData.server_id) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      if (type) {
        this.detailsData = [];
      }

      this.reqLoadingOne = true;
      this.paramsData.page = e;
      szUserInfoNew(_objectSpread(_objectSpread({}, this.paramsData), this.defaultData())).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  if (res.status == 200) {
                    res.data.data.forEach(function (i) {
                      i.ext = i.ext ? JSON.parse(i.ext) : '';
                      i.recharge_amount = _this8.$utils.conversion(i.recharge_amount).toFixed(2);
                      i.real_time_amount = _this8.$utils.conversion(i.real_time_amount).toFixed(2);
                      i.device_id = i.last_logins ? i.last_logins.device_id : "/";
                      i.last_login_time = i.last_login_time ? i.last_login_time : "/";
                      i.register_time = i.register_time ? i.register_time : "/";
                    });
                    _this8.searchList = res.data.data;
                    _this8.total = res.data.total;

                    _this8.$nextTick(function () {
                      _this8.$refs.container.scrollBy(0, 1);
                    });
                  }

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x4) {
          return _ref2.apply(this, arguments);
        };
      }()).finally(function () {
        _this8.reqLoadingOne = false;
      });
    },
    searchClickSizeChange: function searchClickSizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1, true);
    },
    getpropertyList: function getpropertyList(data) {
      var _this9 = this;

      this.property = [];
      this.reqLoadingTow = true;
      SzesourceDescList(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.paramsData), this.propertyparamsData), this.userData), {}, {
        starttime: this.singledate[0],
        endtime: this.singledate[1]
      })).then(function (res) {
        if (res.status == 200) {
          res.processedData && res.processedData.map(function (item) {
            item.user_id = _this9.detailsData[0].user_id;
            item.role_id = _this9.detailsData[0].role_id;
            item.device_id = _this9.detailsData[0].last_logins ? _this9.detailsData[0].last_logins.device_id : '/';
            item.kind = _this9.kindList.findIndex(function (i) {
              return i.value == item.kind;
            }) > -1 ? _this9.kindList.find(function (i) {
              return i.value == item.kind;
            }).label : item.kind;
          });
          _this9.property = res.processedData || [];
          _this9.propertyTotal = res.data.total || 0;
        }
      }).finally(function () {
        _this9.reqLoadingTow = false;
      });
    },
    exportAll: function exportAll() {
      var _this10 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(resolve, reject) {
          var queue, query;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  queue = [];
                  _context8.next = 3;
                  return SzesourceDescList(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this10.paramsData), _this10.propertyparamsData), _this10.userData), {}, {
                    starttime: _this10.singledate[0],
                    endtime: _this10.singledate[1],
                    page_size: -1,
                    page: 1
                  }));

                case 3:
                  query = _context8.sent;

                  if (query.status == 200) {
                    queue = query.data;
                  } else {
                    reject();
                  }

                  resolve(queue);

                case 6:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    exportproperty: function exportproperty() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var exportData, columns;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this11.exportdataDealoading = true;
                _context9.next = 3;
                return _this11.exportAll();

              case 3:
                exportData = _context9.sent;
                exportData.forEach(function (item) {
                  var _loop = function _loop(k) {
                    item[k] = "";

                    if (k == 'retain') {
                      item.resource[k].forEach(function (a, index) {
                        item[k] += "".concat(a.item_name, ":").concat(a.item_num).concat(index != item.resource[k].length - 1 ? "," : "");
                      });
                    }
                  };

                  for (var k in item.resource) {
                    _loop(k);
                  }

                  var _loop2 = function _loop2(m) {
                    item[m] = "";
                    item.new_resource[m].forEach(function (a, indexs) {
                      if (m.includes("_num")) {
                        item[m] = Number(a);
                      } else {
                        item[m] = a;
                      }
                    });
                  };

                  for (var m in item.new_resource) {
                    _loop2(m);
                  }
                });
                columns = [{
                  label: _this11.$t('userId'),
                  prop: "user_id_str"
                }, {
                  label: _this11.$t('roleId'),
                  prop: "role_id"
                }, {
                  label: _this11.$t('deviceId'),
                  prop: "device_id_str"
                }, {
                  label: 'ext',
                  prop: 'ext'
                }, {
                  label: _this11.$t('consumption'),
                  prop: 'cost'
                }, {
                  label: _this11.$t('consumptionName'),
                  prop: 'cost_name'
                }, {
                  label: _this11.$t('consumptionQuantity'),
                  prop: 'cost_num'
                }, {
                  label: _this11.$t('output'),
                  prop: 'output'
                }, {
                  label: _this11.$t('outputName'),
                  prop: 'output_name'
                }, {
                  label: _this11.$t('outputQuantity'),
                  prop: 'output_num'
                }, {
                  label: _this11.$t('retention'),
                  prop: 'retain'
                }, {
                  label: _this11.$t('operation'),
                  prop: "action"
                }, {
                  label: _this11.$t('operationName'),
                  prop: "action_name"
                }, {
                  label: _this11.$t('date'),
                  prop: "new_date"
                }, {
                  label: _this11.$t('time'),
                  prop: "new_time"
                }];

                _this11.$export.excel({
                  columns: columns,
                  data: exportData,
                  title: _this11.$t('items')
                });

                _this11.exportdataDealoading = false;

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    emperor: function emperor(row, type) {
      this.emperorType = type;
      this.emperorData = row;
      this.$refs.addEmperor.open(row, type);
    },
    addEmperorChange: function addEmperorChange(e) {
      var _this12 = this;

      var indexList = this.searchList.filter(function (i) {
        return i.role_id == e;
      });
      indexList.forEach(function (i) {
        var index = _this12.searchList.findIndex(function (j) {
          return i.id == j.id;
        });

        _this12.searchList[index].ban_info = _this12.searchList[index].ban_info == 0 ? 1 : 0;
      });
    },
    getBackpackDetails: function getBackpackDetails() {
      var _this13 = this;

      this.reqLoadingTow = true;
      SzBagDesc(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.propertyparamsData), this.paramsData), this.userData), {}, {
        starttime: "",
        endtime: ""
      })).then(function (res) {
        if (res.status == 200) {
          var _list2 = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          _this13.tableData = res.data.length ? _this13.$utils.dataConversion(res.data, _list2) : [];
          _this13.currentPage = 1;
          _this13.tableCopyTableList = JSON.parse(JSON.stringify(_this13.tableData));
          _this13.tableData = _this13.currentChangePage(_this13.pageSize, _this13.currentPage);
        }
      }).finally(function () {
        _this13.reqLoadingTow = false;
      });
    },
    getOrderList: function getOrderList() {
      var _this14 = this;

      this.reqLoadingTow = true;
      var reqFn = this.searchCurrency.length ? SzRechargeGameCurrency : SzRechargeGame;
      reqFn(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.paramsData), this.userData), this.orderparamsData), this.defaultData('orderparamsData')), {}, {
        role_id: ''
      })).then(function (res) {
        if (res.status == 200) {
          var _list3 = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          _this14.orderData = res.data.data.length ? _this14.$utils.dataConversion(res.data.data, _list3) : [];
          _this14.orderTotal = res.data.total;

          _this14.$nextTick(function () {
            _this14.$refs.container.scrollBy(0, 1000000);
          });
        }
      }).finally(function () {
        _this14.reqLoadingTow = false;
      });
    },
    exportdata: function exportdata() {
      var _this15 = this;

      this.exportLoading = true;
      var reqFn = this.searchCurrency.length ? SzRechargeGameAllCurrency : SzRechargeGameAll;
      reqFn(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.paramsData), this.userData), this.orderparamsData), this.defaultData('orderparamsData')), {}, {
        role_id: ''
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this15.$t('adChannel'),
            prop: "ad_channel_reveal"
          }, {
            label: _this15.$t('adPosition'),
            prop: "ad_placement_reveal"
          }, {
            label: _this15.$t('country'),
            prop: "country"
          }, {
            label: _this15.$t('devOrderId'),
            prop: "order_id"
          }, {
            label: _this15.$t('channelOrderId'),
            prop: "pay_channel_order_id"
          }, {
            label: _this15.$t('userId'),
            prop: "user_id"
          }, {
            label: _this15.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this15.$t('deviceId'),
            prop: "device_id"
          }, {
            label: _this15.$t('paymentAmount'),
            prop: "amount"
          }, {
            label: _this15.$t('rechargeProductId'),
            prop: "product_id"
          }, {
            label: _this15.$t('rechargeProductName'),
            prop: "product_name"
          }, {
            label: _this15.$t('rechargeTime'),
            prop: "timestamp"
          }, {
            label: _this15.$t('ipAddress'),
            prop: "ip"
          }];
          var _list4 = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          var data = res.data.length ? _this15.$utils.dataConversion(res.data, _list4) : [];
          data.map(function (item) {
            item.amount = _this15.$utils.conversion(item.amount).toFixed(2);
          });

          _this15.$export.excel({
            columns: columns,
            data: data,
            title: _this15.$t('orders')
          });
        }
      }).finally(function () {
        _this15.exportLoading = false;
      });
    },
    getuserEmail: function getuserEmail() {
      var _this16 = this;

      this.reqLoadingTow = true;
      SzEmailList(_objectSpread(_objectSpread(_objectSpread({}, this.propertyparamsData), this.userData), {}, {
        uids: this.userData.role_id,
        env_id: this.paramsData.env_id
      })).then(function (res) {
        if (res.status == 200) {
          _this16.emailList = res.data;
        }
      }).finally(function () {
        _this16.reqLoadingTow = false;
      });
    },
    getSzLoginListFn: function getSzLoginListFn() {
      var _this17 = this;

      this.reqLoadingTow = true;
      var params = {
        env_id: this.paramsData.env_id,
        game_id: this.paramsData.game_id,
        kind: this.orderparamsData.kind
      };
      getSzLoginList(_objectSpread(_objectSpread({}, params), this.userData)).then(function (res) {
        if (res.status == 200) {
          _this17.loginList = res.data;
        }
      }).finally(function () {
        _this17.reqLoadingTow = false;
      });
    },
    getbagRetainDescFn: function getbagRetainDescFn() {
      var _this18 = this;

      this.reqLoadingTow = true;
      bagRetainDesc(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.paramsData), this.userData), this.bagRetainparamsData), this.defaultData('bagRetainparamsData'))).then(function (res) {
        if (res.status == 200) {
          var tableNewdata = res.data.data;
          tableNewdata.forEach(function (item) {
            var foundData = _this18.serverListYJ.find(function (b) {
              return b.serverID == item.server_id;
            });

            item.server_name = foundData ? foundData.serverName : '/';
          });
          _this18.bgTableCopyTableList = JSON.parse(JSON.stringify(tableNewdata));
          _this18.bagRetainList = _this18.bgCurrentChangePage(_this18.bgPageSize, _this18.bgCurrentPage);
        }
      }).finally(function () {
        _this18.reqLoadingTow = false;
      });
    },
    gotoEquipItem: function gotoEquipItem(row) {
      this.equipmentparamsData.user_id = row.user_id;
      this.equipmentparamsData.role_id = row.role_id;
      this.checkedCities = '8';
      this.getequipmentFn();
    },
    exportBagdata: function exportBagdata() {
      var columns = [{
        label: this.$t('date'),
        prop: "date"
      }, {
        label: this.$t('game'),
        prop: "game"
      }, {
        label: this.$t('platform'),
        prop: "platform"
      }, {
        label: this.$t('channel'),
        prop: "channel"
      }, {
        label: this.$t('packageName'),
        prop: "pkg"
      }, {
        label: this.$t('roleId'),
        prop: "role_id"
      }, {
        label: this.$t('serverName'),
        prop: "server_name"
      }, {
        label: this.$t('roleName'),
        prop: "role_name"
      }, {
        label: this.$t('itemName'),
        prop: "item_name"
      }, {
        label: this.$t('itemId'),
        prop: "item_id"
      }, {
        label: this.$t('quantity'),
        prop: "total_num"
      }];
      var data = this.bgTableCopyTableList;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$t('playerBackpackDetails')
      });
    },
    getequipmentFn: function getequipmentFn() {
      var _this19 = this;

      this.equipmentData = [];
      this.reqLoadingTow = true;
      equipResource(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.paramsData), this.userData), this.equipmentparamsData), this.defaultData('equipmentparamsData'))).then(function (res) {
        if (res.code == 200) {
          _this19.equipmentData = res.data;
          _this19.equipmentTotal = res.total;
        }
      }).finally(function () {
        _this19.reqLoadingTow = false;
      });
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    handleCurrentChange1: function handleCurrentChange1(currentPage) {
      var _this20 = this;

      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
      this.$nextTick(function () {
        _this20.$refs.container.scrollBy(0, 1000000);
      });
    },
    backSizeChange: function backSizeChange(e) {
      this.pageSize = e;
      this.handleCurrentChange1(1);
    },
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    bgHandleSizeChange: function bgHandleSizeChange(pageSize) {
      this.bgCurrentPage = 1;
      this.bgPageSize = pageSize;
      this.bagRetainList = this.bgCurrentChangePage(pageSize, this.currentPage);
    },
    bgHandleCurrentChange: function bgHandleCurrentChange(currentPage) {
      this.bgCurrentPage = currentPage;
      this.bagRetainList = this.bgCurrentChangePage(this.bgPageSize, currentPage);
    },
    bgCurrentChangePage: function bgCurrentChangePage(size, current) {
      var tablePush = [];
      this.bgTableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },
    renderheader: function renderheader(h, _ref4, desc) {
      var column = _ref4.column,
          $index = _ref4.$index;
      return h("div", {
        style: {
          display: "flex",
          "align-items": "center"
        }
      }, [h("div", {
        style: {
          display: "flex",
          "flex-direction": "column",
          "align-items": "center"
        }
      }, [h("div", {}, column.label.split(".")[0]), h("div", {}, column.label.split(".")[1])]), desc ? h("el-tooltip", {
        props: {
          content: desc,
          placement: "top"
        }
      }, [h("span", {
        class: {
          "el-icon-question": true
        }
      })]) : ""]);
    }
  }
};